import SimulationLink from "../components/SimulationLink";

export default {
  render(h) {
    return (
      <div class="py-5">
        <div class="shadow-md mx-3 lg:mx-6 bg-white rounded">
          <div class="p-6 py-10 lg:px-24">
            <div class="border-b-2 border-brand-gray-500 inline-block mb-1">
              <p class="text-gray-600 lg:text-2xl leading-tight">Introduction</p>
            </div>

            <p class="text-3xl lg:text-5xl font-bold text-brand-blue-600">
              Executing Change
            </p>

            <p class="lg:text-2xl mt-3">
              This section is the core simulation that prepares learners to execute change management. Learners read
              more about the scenario and stakeholders introduced in section one. They then need to progressively select
              actions to take over time to implement the change in several areas. Learners receive information about the
              results of their choices and coach feedback throughout the simulation, but ultimately the choice of the
              order of actions is their own. If learners don’t reach their goal, or if they simply want to see what
              would have happened if they had selected different choices, they can restart the core simulation after
              reviewing a summary and debrief.
            </p>

            <SimulationLink
              to="what-to-do"
              text="Continue"
              class="inline-block mt-5 rounded-full bg-brand-orange-700 text-white uppercase py-2 px-10 lg:text-xl hover:bg-orange-700 focus:outline-none transition-colors duration-100"
            />
          </div>
        </div>
      </div>
    );
  }
}
